import React from "react";

import { BorderedBlock } from "../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { SelectField } from "../../../../../../features/forms/fields/select-field/select-field.component";

import { CbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control.props";

import { NumberOfStoresOptions } from "../../types/number-of-stores-options.constant";

export const CbTemplateControlNumberOfStores = (props: CbTemplateControlProps) => (
  <BorderedBlock>
    <SelectField
      form={props.form}
      label="Number of Launch Stores"
      name="numberOfStores"
      options={NumberOfStoresOptions}
      userPermissions={props.userPermissions}
    />
  </BorderedBlock>
);
